import { Component, Input } from '@angular/core';
import { JobListSchema } from '@app/schemas/jobs';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-job-description',
  imports: [
    NgClass
  ],
  templateUrl: './job-description.component.html',
  styleUrl: './job-description.component.css'
})
export class JobDescriptionComponent {
   @Input() job: JobListSchema = {} as JobListSchema;
}
